import { Flex, IconButton, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';
import { Trans } from '@lingui/react/macro';
import { ArrowRightFromLine } from 'lucide-react';
import { useState, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSubSidebar } from '@duke-hq/ui/components/SubSidebar/useSubSidebar';

import { SitesLocations } from './SitesLocations';
import { RegionsLocations } from './RegionsLocations';
import { SiteFormModal } from './SiteFormModal';
import { RegionFormModal } from './RegionFormModal';
import { withPermission } from '../../withPermission';

export const LocationsPage = withPermission('canViewProviders', () => {
  const { siteId, regionId } = useParams<{ siteId: string; regionId: string }>();
  const initialActiveTab = siteId ? 0 : regionId ? 1 : 0;

  const [activeTab, setActiveTab] = useState(initialActiveTab);
  const [_searchParams, setSearchParams] = useSearchParams();
  const { isExpanded, toggleExpandSubSidebar } = useSubSidebar();

  const handleTabChange = useCallback(
    (index: number) => {
      setActiveTab(index);
      setSearchParams({});
    },
    [setSearchParams],
  );

  return (
    <>
      <Flex flexDirection="column">
        <Flex p="4" align="center" justify="space-between">
          <Flex alignItems="center" gap="2">
            {!isExpanded && (
              <IconButton
                aria-label="expand secondary sidebar"
                icon={<ArrowRightFromLine />}
                variant="tertiary"
                onClick={toggleExpandSubSidebar}
                size="md"
              />
            )}
            <PageHeading>
              <Trans>Locations</Trans>
            </PageHeading>
          </Flex>
          <Flex justify="end" alignItems="center" gap="2">
            <SiteFormModal />
            <RegionFormModal />
          </Flex>
        </Flex>
      </Flex>

      <Tabs isLazy index={activeTab} onChange={handleTabChange}>
        <TabList bg="bg.subtle">
          <Tab bg={activeTab === 0 ? 'bg.surface' : ''}>
            <Trans>Sites</Trans>
          </Tab>
          <Tab bg={activeTab === 1 ? 'bg.surface' : ''}>
            <Trans>Regions</Trans>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel p="0" display="flex" width="100%" height="100%" overflow="auto">
            <SitesLocations />
          </TabPanel>
          <TabPanel p="0" display="flex" width="100%" height="100%" overflow="auto">
            <RegionsLocations />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
});
